import React from 'react';
import { Box, Paper, Typography, Avatar, useMediaQuery, useTheme, Link } from '@mui/material';
import { formatMessageTime } from '../utils/dateFormatter';
import OptionButtons from './OptionButtons';

const Message = ({ message, isBot, onOptionSelect }) => {
  const theme = useTheme();
  // eslint-disable-next-line no-unused-vars
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isBot ? 'flex-start' : 'flex-end',
        mb: { xs: 1.5, sm: 2 },
        gap: { xs: 0.5, sm: 1 },
        px: { xs: 0.5, sm: 0 },
      }}
    >
      {isBot && (
        <Avatar
          sx={{
            bgcolor: '#e9e9e9',
            width: { xs: 32, sm: 40 },
            height: { xs: 32, sm: 40 },
            alignSelf: 'center',
            mb: 0.5,
          }}
        >
          <img src={require('../assets/image.png')} alt="Logo" style={{ width: '80%', height: '80%', objectFit: 'contain' }} />
        </Avatar>
      )}
      <Box
        sx={{
          maxWidth: { xs: '75%', sm: '70%', md: '65%' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: isBot ? 'flex-start' : 'flex-end',
        }}
      >
        <Paper
          elevation={1}
          sx={{
            p: { xs: 1.5, sm: 2 },
            backgroundColor: isBot ? '#fff' : '#EDD3E7',
            color: isBot ? 'text.primary' : '#000',
            borderRadius: 2,
            position: 'relative'
          }}
        >
          <Typography 
            variant="body1" 
            sx={{ 
              whiteSpace: 'pre-wrap', 
              wordBreak: 'break-word',
              fontSize: { xs: '0.875rem', sm: '1rem' } 
            }}
          >
            {message.message}
            {message.link && (
              <Link 
                href={message.link.url} 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ 
                  display: 'block',
                  mt: 1, 
                  color: '#9D1680',
                  fontWeight: 500,
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                {message.link.text} →
              </Link>
            )}
          </Typography>
          {message.options && isBot && (
            <OptionButtons options={message.options} onSelect={onOptionSelect} />
          )}
        </Paper>
        <Typography
          variant="caption"
          sx={{
            mt: 0.5,
            color: 'text.secondary',
            fontSize: { xs: '0.7rem', sm: '0.75rem' },
          }}
        >
          {formatMessageTime(message.timestamp || new Date())}
        </Typography>
      </Box>
    </Box>
  );
};

export default Message;